// extracted by mini-css-extract-plugin
export var avatar = "_os-3";
export var avatarContainer = "_os-2";
export var avatarSpacer = "_os-5";
export var avatarSpacerContainer = "_os-4";
export var avatarStackContainer = "_os-1";
export var bubble = "_os-0";
export var remainderBubble = "_os-6";